/**
 *
 * Asynchronously loads the component for SetupLoader
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const SetupLoader = lazyLoad(
  () => import('./index'),
  module => module.SetupLoader,
);
